import React from "react";
import { Location, LocationContext } from "@reach/router";
import { useQuery } from "@apollo/client";
import { gql } from "graphql-tag";
import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { Home } from "@material-ui/icons";
import { ServerError, LoadingSpinner } from "components/graphql-views";
import { Viewer } from "components/auth/types";
import { List, sortAndFilterLists } from "./list-utils";

type Data = {
  organization: {
    id: string;
    interestLists: [List];
  };
};

const ORG_LISTS = gql`
  query getOrgLists($orgId: ID!) {
    organization(id: $orgId) {
      id
      interestLists {
        id
        name
      }
    }
  }
`;

interface Props {
  viewer: Viewer;
}
interface ListItemProps {
  list: List;
  currentPath: string;
  context: LocationContext
}

const ListItem = ({ list, context, currentPath }: ListItemProps) => (
  <MenuItem button selected={currentPath?.includes(list.id)}
    onClick={() => {
      context.navigate(`/dash/manager/settings/property/${list.id}/lists`);
    }}
    dense
  >
    <ListItemIcon style={{ minWidth: "36px" }}><Home /></ListItemIcon>
    <ListItemText>
      {list.name}
    </ListItemText>
  </MenuItem>
);
const ListsSidebar:React.FC<Props> = ({ viewer }) => {
  const orgId = viewer.organizationId;
  if (!orgId) return null;
  const { loading, error, data } = useQuery<Data>(ORG_LISTS, { fetchPolicy: "cache-and-network", variables: { orgId } });

  if (error) return <ServerError desc={error.message} />;
  if (loading) return <LoadingSpinner />;
  if (!data) return <ServerError desc="Missing Data" />;

  const lists =
      sortAndFilterLists(viewer, data.organization.interestLists);

  return (
    <div>
      <Location>
        {(context) => {
          const currentPath = context.location.pathname;
          return (
            <div>
              {lists
                .map((list) => <ListItem
                  key={list.id}
                  list={list}
                  currentPath={currentPath}
                  context={context}
                />)}
            </div>
          );
        }}

      </Location>

    </div>
  );
};

export default ListsSidebar;
